import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 447 447",
  "content": "<symbol viewBox=\"0 0 447 447\" id=\"icon-account\">\r\n<path d=\"M381.5,65.5C339.3,23.3,283.2,0,223.5,0s-115.8,23.3-158,65.5C23.3,107.7,0,163.8,0,223.5s23.3,115.8,65.5,158\r\n\tc2.5,2.5,5,4.9,7.6,7.2c3.6,3.3,7.3,6.4,11.1,9.5c39.5,31.6,88.1,48.8,139.4,48.8c51.3,0,99.9-17.2,139.4-48.8\r\n\tc3.8-3,7.5-6.2,11.1-9.5c2.6-2.4,5.1-4.8,7.6-7.2c42.2-42.2,65.5-98.3,65.5-158S423.8,107.7,381.5,65.5z M223.5,434\r\n\tc-51.7,0-99-18.7-135.7-49.7c21.8-73.5,74.4-125.5,135.7-125.5s113.8,51.9,135.7,125.5C322.5,415.3,275.2,434,223.5,434z M146,168.3\r\n\tc0-42.7,34.8-77.5,77.5-77.5s77.5,34.8,77.5,77.5c0,42.7-34.8,77.5-77.5,77.5S146,211.1,146,168.3z M369.8,374.7\r\n\tc-7.8-24-18.8-46.1-32.9-65.3c-21.5-29.3-48.2-49.1-77.3-58.1c32-14,54.4-45.9,54.4-83c0-49.9-40.6-90.5-90.5-90.5\r\n\tS133,118.4,133,168.3c0,37.1,22.4,69,54.4,83c-29.1,9-55.8,28.8-77.3,58.1c-14.1,19.1-25.2,41.2-32.9,65.3\r\n\tC37.6,336.4,13,282.8,13,223.5C13,107.4,107.4,13,223.5,13S434,107.4,434,223.5C434,282.8,409.4,336.4,369.8,374.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/account.svg
// module id = h+4i
// module chunks = 0